import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";
import { ENV } from "../env";

const shouldTrackAnalytics = () => ENV === "production";

const removeEmptyValues = (parameters = {}) =>
  Object.fromEntries(
    Object.entries(parameters).filter(
      ([, value]) => value !== undefined && value !== null && value !== "",
    ),
  );

const buildDigiseqParameters = ({
  eventId,
  serialNumber,
  guestId,
  buttonName,
  userAction,
  location,
  ...rest
} = {}) =>
  removeEmptyValues({
    digiseq_event_id: eventId,
    digiseq_serial_number: serialNumber,
    digiseq_guest_id: guestId,
    digiseq_button_name: buttonName,
    digiseq_user_action: userAction,
    digiseq_location: location,
    ...rest,
  });

const normalizePageViewInput = (pageNameOrOptions) =>
  typeof pageNameOrOptions === "string"
    ? { pageTitle: pageNameOrOptions }
    : pageNameOrOptions || {};

const normalizeButtonClickInput = (buttonNameOrOptions, location = "") =>
  typeof buttonNameOrOptions === "string"
    ? { buttonName: buttonNameOrOptions, location }
    : buttonNameOrOptions || {};

const normalizeUserActionInput = (actionOrOptions, details = {}) =>
  typeof actionOrOptions === "string"
    ? { userAction: actionOrOptions, ...details }
    : actionOrOptions || {};

export const trackEvent = (eventName, parameters = {}) => {
  if (!shouldTrackAnalytics()) {
    console.log(`[Analytics] Skipped in ${ENV}:`, eventName, parameters);
    return;
  }

  try {
    logEvent(analytics, eventName, parameters);
    console.log(`[Analytics] Tracked:`, eventName, parameters);
  } catch (error) {
    console.warn("Analytics tracking failed:", error);
  }
};

export const trackPageView = (pageNameOrOptions) => {
  const {
    pageTitle,
    eventId,
    serialNumber,
    guestId,
    location = window.location.href,
    ...rest
  } = normalizePageViewInput(pageNameOrOptions);

  trackEvent("page_view", {
    page_title: pageTitle,
    ...buildDigiseqParameters({
      eventId,
      serialNumber,
      guestId,
      location,
      ...rest,
    }),
  });
};

export const trackButtonClick = (buttonNameOrOptions, location = "") => {
  const normalizedInput = normalizeButtonClickInput(buttonNameOrOptions, location);

  trackEvent("button_click", buildDigiseqParameters(normalizedInput));
};

export const trackFormSubmit = (formNameOrOptions) => {
  const normalizedInput =
    typeof formNameOrOptions === "string"
      ? { formName: formNameOrOptions }
      : formNameOrOptions || {};
  const { formName, ...rest } = normalizedInput;

  trackEvent(
    "form_submit",
    buildDigiseqParameters({
      form_name: formName,
      ...rest,
    }),
  );
};

export const trackUserAction = (actionOrOptions, details = {}) => {
  const normalizedInput = normalizeUserActionInput(actionOrOptions, details);

  trackEvent("user_action", buildDigiseqParameters(normalizedInput));
};
